import { PhoneNumber, User } from 'models/User';
import authHttpClient from 'api/authHttpClient';

const authPath = (routePath: TemplateStringsArray) => `auth/${routePath}`;

function changeInitialPassword(password: string) {
  return authHttpClient.patch<User>(authPath`change-temporary-password`, {
    password,
  });
}

function changePhoneNumber(phoneNumber: PhoneNumber) {
  return authHttpClient.post('users/phone-number', phoneNumber);
}

function getCurrentUser() {
  return authHttpClient.get<User>('users/current');
}

function initiateVerification() {
  return authHttpClient.post(authPath`phone-verify`);
}

function verificateCode(verificationCode: string) {
  return authHttpClient.post(authPath`phone-verify/token`, {
    verificationCode,
  });
}

export default {
  changeInitialPassword,
  changePhoneNumber,
  getCurrentUser,
  initiateVerification,
  verificateCode,
};
